<div>
  <mat-spinner [diameter]="40"></mat-spinner>
</div>
